const workbench = {
  funnel_detail: '查看「{{label}}」明细',
  open_purchase: '打开套餐购买',
  today_overview: '今日概览',
  shop_line: '{{region}}店铺 · {{name}}',
  pending_replies: '待回复',
  dm_chip: '私信 {{value}}',
  email_chip: '邮件 {{value}}',
  dm_quota: '私信额度',
  invite_quota: '邀约额度',
  dm_quota_meta: '/ {{total}} 今日 · 剩余 {{remain}}',
  email_this_month: '邮件额度',
  unlimited: '不限',
  delivery_rate: '送达 {{rate}}%',
  authorized_shops: '授权店铺',
  plan_expire: '{{plan}} · 到期 {{date}}',
  plan_benefits: '套餐权益',
  per_month: '/ 月',
  mail_remain: '剩余 {{remain}}',
  addon_included: '含加购 {{extra}}',
  plan_quota: '邮件 {{emails}} · 店铺 {{shops}}',
  addon_packages: '加购权益包',
  addon_empty: '暂无',
  usage_invite: '邀约',
  quota_reset_time: '额度重置时间：',
  quota_reset_hint: '该字段表示额度周期时间节点：本月额度用尽后，若已续费，显示为新额度到账时间；若未续费，显示为额度到期时间。周期重置时，邀约、私信、邮件额度将重置，店铺额度不重置。',
  current_usage: '当前占用：',
  usage_shop: '店铺',
  usage_email: '邮件',
  email_tag: '邮件',
  usage_rest: '/ {{limit}} ( 含加购 {{extra}} )',
  funnel: '建联漏斗',
  funnel_load_failed: '建联漏斗加载失败',
  quick_outreach: '快速建联',
  funnel_matchable: '可匹配',
  funnel_pool: '达人池',
  funnel_dm: '已私信',
  funnel_dm_rate: '转化率 {{rate}}%',
  funnel_emailed: '已发邮件',
  funnel_dm_to_email: '私信→邮件 {{rate}}%',
  targeted_invite: '定向邀约',
  funnel_invite_rate: '邀约率 {{rate}}%',
  funnel_accepted: '已回复/已接受',
  funnel_total_rate: '总转化率 {{rate}}%',
  todos: '待办',
  pending_dms: '待回复私信 {{value}} 条',
  pending_dms_meta: '最后一条由达人发送',
  dm_tag: '私信',
  pending_emails: '待回复邮件 {{value}} 封',
  pending_emails_meta: '达人已回，待商家回复',
  handle: '处理',
  quick_entry: '快捷入口',
  quick_dm: '发私信',
  quick_email: '发邮件',
  quick_upgrade: '购买/升级',
  quick_hint: '店铺仅东南亚，授权成功后可发私信、邮件与定向邀约'
};

export default workbench;
